import { useEffect, useState } from "react";

import { getSettings } from "../services/settingsApi";

import SettingsHeader from "../components/settings/SettingsHeader";
import SettingsTabs from "../components/settings/SettingsTabs";

import GeneralSettings from "../components/settings/GeneralSettings";
import BusinessSettings from "../components/settings/BusinessSettings";
import CommissionSettings from "../components/settings/CommissionSettings";
import DeliverySettings from "../components/settings/DeliverySettings";
import TaxSettings from "../components/settings/TaxSettings";
import EmailSettings from "../components/settings/EmailSettings";
import SMSSettings from "../components/settings/SMSSettings";
import PaymentSettings from "../components/settings/PaymentSettings";
import BrandingSettings from "../components/settings/BrandingSettings";
import ContactSettings from "../components/settings/ContactSettings";
import SocialSettings from "../components/settings/SocialSettings";
import SecuritySettings from "../components/settings/SecuritySettings";
import MaintenanceSettings from "../components/settings/MaintenanceSettings";

import "../css/Settings.css";

function Settings() {

    const [settings, setSettings] = useState({});

    const [loading, setLoading] = useState(true);

    const [activeTab, setActiveTab] = useState("general");

    const loadSettings = async () => {

        try {

            setLoading(true);

            const res = await getSettings();

            setSettings(res.data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadSettings();

    }, []);

    const renderTab = () => {

        switch (activeTab) {

            case "general":
                return (
                    <GeneralSettings
                        settings={settings.general}
                        reload={loadSettings}
                    />
                );

            case "business":
                return (
                    <BusinessSettings
                        settings={settings.business}
                        reload={loadSettings}
                    />
                );

            case "commission":
                return (
                    <CommissionSettings
                        settings={settings.commission}
                        reload={loadSettings}
                    />
                );

            case "delivery":
                return (
                    <DeliverySettings
                        settings={settings.delivery}
                        reload={loadSettings}
                    />
                );

            case "tax":
                return (
                    <TaxSettings
                        settings={settings.tax}
                        reload={loadSettings}
                    />
                );

            case "email":
                return (
                    <EmailSettings
                        settings={settings.email}
                        reload={loadSettings}
                    />
                );

            case "sms":
                return (
                    <SMSSettings
                        settings={settings.sms}
                        reload={loadSettings}
                    />
                );

            case "payment":
                return (
                    <PaymentSettings
                        settings={settings.payment}
                        reload={loadSettings}
                    />
                );

            case "branding":
                return (
                    <BrandingSettings
                        settings={settings.branding}
                        reload={loadSettings}
                    />
                );

            case "contact":
                return (
                    <ContactSettings
                        settings={settings.contact}
                        reload={loadSettings}
                    />
                );

            case "social":
                return (
                    <SocialSettings
                        settings={settings.social}
                        reload={loadSettings}
                    />
                );

            case "security":
                return (
                    <SecuritySettings
                        settings={settings.security}
                        reload={loadSettings}
                    />
                );

            case "maintenance":
                return (
                    <MaintenanceSettings
                        settings={settings.maintenance}
                        reload={loadSettings}
                    />
                );

            default:
                return null;

        }

    };

    if (loading) {

        return (

            <div className="settings-loading">

                Loading Settings...

            </div>

        );

    }

    return (

        <div className="settings-page">

            <SettingsHeader reload={loadSettings} />

            <SettingsTabs

                activeTab={activeTab}

                setActiveTab={setActiveTab}

            />

            <div className="settings-content">

                {renderTab()}

            </div>

        </div>

    );

}

export default Settings;